import { GPUComputationRenderer } from 'three/addons/misc/GPUComputationRenderer.js'

import gpgpuParticlesShader from '../shaders/gpgpu/particles.glsl'
import createBaseParticlesTexture from "./createBaseParticlesTexture"

// Sets up the GPUComputationRenderer, adding the variable and its uniforms.
export default function setupGPUComputation(gl, baseGeometry, count) {
    const gridSize = Math.ceil(Math.sqrt(count))
    const gpu = new GPUComputationRenderer(gridSize, gridSize, gl)
    const baseParticlesTexture = createBaseParticlesTexture(gpu, baseGeometry, count)
    const variable = gpu.addVariable('uParticles', gpgpuParticlesShader, baseParticlesTexture)
    gpu.setVariableDependencies(variable, [variable])

    // Define initial uniforms for the compute shader.
    variable.material.uniforms.uTime = { value: 0 }
    variable.material.uniforms.uDeltaTime = { value: 0 }
    variable.material.uniforms.uBase = { value: baseParticlesTexture }
    variable.material.uniforms.uFlowFieldInfluence = { value: 0.5 }
    variable.material.uniforms.uFlowFieldStrength = { value: 1.5 }
    variable.material.uniforms.uFlowFieldFrequency = { value: 0.3 }

    const error = gpu.init()
    if (error !== null) console.error('GPUComputation init error:', error)

    return { gpu, variable }
}
